export const css = {
	root: '_1iTSQ2ne',
	inputWrapper: 'piRg-mwz',
	select: '_375aJaCz',
	arrow: '_1roxpYYD',
	disabled: '_1pKp4IUc',
	' _key': 'certwise-theme/dojo/native-select'
};

export default css;
